import { render, staticRenderFns } from "./CustomersView.vue?vue&type=template&id=61c1dc42&scoped=true"
import script from "./CustomersView.vue?vue&type=script&lang=ts"
export * from "./CustomersView.vue?vue&type=script&lang=ts"
import style0 from "./CustomersView.vue?vue&type=style&index=0&id=61c1dc42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c1dc42",
  null
  
)

export default component.exports